import { render, staticRenderFns } from "./common-pictureswitching.vue?vue&type=template&id=24bcdac2&scoped=true&"
import script from "./common-pictureswitching.vue?vue&type=script&lang=js&"
export * from "./common-pictureswitching.vue?vue&type=script&lang=js&"
import style0 from "./common-pictureswitching.vue?vue&type=style&index=0&id=24bcdac2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bcdac2",
  null
  
)

export default component.exports